const BASE_URL = "https://funlove.pro/api/product";
const BASE_MEDIA = "https://funlove.b-cdn.net/";
//const BASE_URL = "http://funlove.test/api/product";
export default {
    BASE_URL,
    BASE_MEDIA,
    limit: 10,
    login: "login",
    logout: 'logout',
    home: BASE_URL,
    config:'config',
    movies: {
        list: 'movies/',
        popular: 'popular/',
        detall: "movie/",
        like:"movie/like/",
        view:"movie/view/",
        iframeVideo:"iframe-video/"
    },
    Menu: 'menus',
    category: {
        menus: 'menus',
        movieByCategory: 'categories/'
    },
    porntStar: {
        list: 'pornstars/',
        detall: 'pornstar/',
    }


}
